import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      static o43(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.g43_1 = operation;
        $this.h43_1 = requestUuid;
        $this.i43_1 = data;
        $this.j43_1 = errors;
        $this.k43_1 = extensions;
        $this.l43_1 = exception;
        $this.m43_1 = Companion_getInstance().d42_1;
        $this.n43_1 = false;
        return $this;
      }
      static p43(operation, requestUuid) {
        return this.o43(operation, requestUuid, null, null, null, null);
      }
      q43(executionContext) {
        // Inline function 'kotlin.apply' call
        this.m43_1 = this.m43_1.r43(executionContext);
        return this;
      }
      s43(data) {
        // Inline function 'kotlin.apply' call
        this.i43_1 = data;
        return this;
      }
      t43(errors) {
        // Inline function 'kotlin.apply' call
        this.j43_1 = errors;
        return this;
      }
      u43(exception) {
        // Inline function 'kotlin.apply' call
        this.l43_1 = exception;
        return this;
      }
      v43(extensions) {
        // Inline function 'kotlin.apply' call
        this.k43_1 = extensions;
        return this;
      }
      e42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.h43_1 = requestUuid;
        return this;
      }
      w43(isLast) {
        // Inline function 'kotlin.apply' call
        this.n43_1 = isLast;
        return this;
      }
      y36() {
        var tmp1_operation = this.g43_1;
        var tmp2_requestUuid = this.h43_1;
        var tmp3_data = this.i43_1;
        var tmp4_executionContext = this.m43_1;
        var tmp0_elvis_lhs = this.k43_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.j43_1;
        var tmp7_exception = this.l43_1;
        var tmp8_isLast = this.n43_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.x43_1 = requestUuid;
        this.y43_1 = operation;
        this.z43_1 = data;
        this.a44_1 = errors;
        this.b44_1 = exception;
        this.c44_1 = extensions;
        this.d44_1 = executionContext;
        this.e44_1 = isLast;
      }
      f44() {
        var tmp;
        if (this.t44()) {
          throw ApolloGraphQLException().s44(first(ensureNotNull(this.a44_1)));
        } else if (!(this.b44_1 == null)) {
          throw DefaultApolloException().l44('An exception happened', this.b44_1);
        } else {
          tmp = this.g44();
        }
        return tmp;
      }
      g44() {
        var tmp0_elvis_lhs = this.z43_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().y44(this.b44_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      t44() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.a44_1;
        return !(this_0 == null || this_0.n1());
      }
      e43() {
        return Builder().o43(this.y43_1, this.x43_1, this.z43_1, this.a44_1, this.c44_1, this.b44_1).q43(this.d44_1).w43(this.e44_1);
      }
      toString() {
        var tmp = 'operationName=' + this.y43_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.z43_1 == null ? 'null' : this.y43_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.a44_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.b44_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.b44_1).j1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
  ApolloResponse as ApolloResponse1aeginapbuksm,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
